import { inject, Injectable, Injector, signal } from '@angular/core';
import {
  TemplateHandlebarKeysToCheck,
  WidgetActionsSelector,
  widgetActionsToHandlebarKeyMap,
} from '../../utils/template/widget-template-helpers/action-to-handlebar-key-map';
import { handlebarToStateActionMap } from '../../utils/template/widget-template-helpers/handlebar-key-to-state-selector-map';

@Injectable({
  providedIn: 'root',
})
export class WidgetTemplateHelperService {
  private readonly injector = inject(Injector);

  public widgetAction = signal<WidgetActionsSelector | undefined>(undefined);

  public setWidgetAction(action: WidgetActionsSelector) {
    this.widgetAction.set(action);
  }

  public resetWidgetAction() {
    this.widgetAction.set(undefined);
  }

  public checkWidgetTemplateAndDispatchStateUpdateIfNeeded(template: string): void {
    const widgetAction = this.widgetAction();
    if (!widgetAction) return;
    const handlebarKeysToCheck = widgetActionsToHandlebarKeyMap.get(widgetAction);
    if (!handlebarKeysToCheck?.length) return;

    for (const key of handlebarKeysToCheck) {
      if (!template.includes(key)) continue;
      const action = handlebarToStateActionMap.get(key as TemplateHandlebarKeysToCheck);
      if (!action) continue;
      action(this.injector);
      this.resetWidgetAction();
      return;
    }
  }
}
